<template>
  <div>
    <div class="headbg">
    </div>
    <div class="hot">
      <Row :gutter="20">
        <Col :span="6" v-for="(item,index) in datalist" :key="index">
        <a :href="item.link" target="_blank">
          <div class="item">
            <img :src="item.img" alt="">
            <div class="wrap">
              <h5>{{ item.title }}</h5>
              <p>{{ item.des }}</p>
              <svg t="1710741666828" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5375" width="26" height="26"><path d="M769.906931 208.491475 811.109332 249.731738 208.499661 857.969593 167.29726 816.72933Z" p-id="5376"></path><path d="M856.70274 420.186921 602.546226 166.030407 856.70274 166.030407Z" p-id="5377"></path></svg>
            </div>
          </div>
        </a>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      // 本地
      // datalist: [
      //   {
      //     title: "线路客流特征分析实验",
      //     des: "OD数据的认识；断面客流计算；客流时空分布特征分析。",
      //     img: require("../../assets/home/pic01.png"),
      //     link: "http://192.168.0.114:62003",
      //   },
      //   {
      //     title: "列车开行方案设计实验",
      //     des: "交路设置；全日分时段运力配置；运力负荷验算及优化。",
      //     img: require("../../assets/home/pic02.png"),
      //     link: "http://192.168.0.114:62004",
      //   },
      //   {
      //     title: "运行图编制实验",
      //     des: "运行图铺画；车底周转计划编制；运行图仿真评估及优化。",
      //     img: require("../../assets/home/pic03.png"),
      //     link: "http://192.168.0.114:62005",
      //   },
      //   {
      //     title: "乘务计划编制实验",
      //     des: "乘务员分班设置；车次任务分配；乘务计划调整及优化。",
      //     img: require("../../assets/home/pic04.png"),
      //     link: "http://192.168.0.114:62006",
      //   },
      //   {
      //     title: "列车模拟驾驶实验",
      //     des: "驾驶室设备功能认知；驾驶操作学习。",
      //     img: require("../../assets/home/pic05.png"),
      //     link: "http://mnjs.yoodao.net",
      //   },
      //   {
      //     title: "突发事件应急处置实验",
      //     des: "车站设备认知及操作；故障处理方式及流程学习。",
      //     img: require("../../assets/home/pic06.png"),
      //     link: "http://tfyj.yoodao.net",
      //   },
      //   {
      //     title: "车站设备运用与客流组织实验",
      //     des: "车站设施设备摆放；乘客进出站流线铺画；车站客流仿真。",
      //     img: require("../../assets/home/pic07.png"),
      //     link: "",
      //   },
      //   {
      //     title: "城轨列车运行能耗仿真实验",
      //     des: "列车运行操纵模式优化；运行能耗仿真及参数分析。",
      //     img: require("../../assets/home/pic08.png"),
      //     link: "http://192.168.5.35:8088/",
      //   },
      // ],
      // 线上
      datalist: [
        {
          title: "线路客流特征分析实验",
          des: "OD数据的认识；断面客流计算；客流时空分布特征分析。",
          img: require("../../assets/home/pic01.png"),
          link: "http://urtom.pfa.yoodao.net",
        },
        {
          title: "列车开行方案设计实验",
          des: "交路设置；全日分时段运力配置；运力负荷验算及优化。",
          img: require("../../assets/home/pic02.png"),
          link: "http://urtom.osd.yoodao.net",
        },
        {
          title: "运行图编制实验",
          des: "运行图铺画；车底周转计划编制；运行图仿真评估及优化。",
          img: require("../../assets/home/pic03.png"),
          link: "http://urtom.td.yoodao.net",
        },
        {
          title: "乘务计划编制实验",
          des: "乘务员分班设置；车次任务分配；乘务计划调整及优化。",
          img: require("../../assets/home/pic04.png"),
          link: "http://urtom.cp.yoodao.net",
        },
        {
          title: "列车模拟驾驶实验",
          des: "驾驶室设备功能认知；驾驶操作学习。",
          img: require("../../assets/home/pic05.png"),
          link: "http://mnjs.yoodao.net",
        },
        {
          title: "突发事件应急处置实验",
          des: "车站设备认知及操作；故障处理方式及流程学习。",
          img: require("../../assets/home/pic06.png"),
          link: "http://tfyj.yoodao.net",
        },
        {
          title: "车站设备运用与客流组织实验",
          des: "车站设施设备摆放；乘客进出站流线铺画；车站客流仿真。",
          img: require("../../assets/home/pic07.png"),
          link: "",
        },
        {
          title: "城轨列车运行能耗仿真实验",
          des: "列车运行操纵模式优化；运行能耗仿真及参数分析。",
          img: require("../../assets/home/pic08.png"),
          link: "http://nh.yoodao.net",
        },
      ],
    };
  },
  setup() {},
  methods: {
    handleClick() {
      this.$Message.info("Welcome to View UI Plus Demo!");
    },
  },
};
</script>
<style lang="less" scoped>
.headbg {
  height: 250px;
  width: 100%;
  background: url(../../assets/online/banner2.png) no-repeat center;
  overflow: hidden;
}
.hot {
  width: 1200px;
  margin: 30px auto 0;
  .item {
    width: 270px;
    cursor: pointer;
    margin: 0 auto 20px;
    img {
      width: 270px;
      border-radius: 5px 5px 0 0;
      vertical-align: middle
    }
    .wrap{
      transition: 0.5s;
      height: 86px;
      position: relative;
      padding: 10px;
      svg{
        position: absolute;
        top: 10px;
        right: 0px;
        fill: #999;
        height: 20px;
        transition: 0.5s;
      }
    }
    h5{
      font-size: 16px;
      color: #333;
      transition: 0.5s;
    }
    p {
      width: 100%;
      color: #666;
      font-size: 12px;
      line-height: 18px;
      margin-top: 6px;
      transition: 0.5s;
    }
  }
  a{
    &:hover{
      .wrap{
        background: #E12427;
        h5{
          color: #fff;
        }
        p{
          color: #fff;
        }
        svg{
          fill: #fff;
        }
      }
    }
  }
}
</style>

